window.togglePreset = function () {
  var x = document.getElementById("prescription_preset_search_form");
  if (x.style.display === "none") {
    x.style.display = "block";
  } else {
    x.style.display = "none";
  }
}

// autocomplete 
document.addEventListener("turbolinks:load", function () {
  $input = $('*[data-behavior="preset-autocomplete"]');
  var options = {
    url: function (phrase) {
      return "/prescription_presets/autocomplete.json?q=" + phrase;
    },
    getValue: "item",
    list: {
      onChooseEvent: function () {
        var name = $input.getSelectedItemData().name
        $input.val(name)
      }
    },
  };

  $input.easyAutocomplete(options);
});

window.toggleDiscount = function () {
  var x = document.getElementById("prescription_discount_form");
  if (x.style.display === "none") {
    x.style.display = "block";
  } else {
    x.style.display = "none";
  }
}

window.toggleSecondaryInventoryWarnng = function () {
  var x = document.getElementById("secondary-inventory-warning");
  x.style.display = "block";
  document.getElementById("toggle-secondary-inventory-warning").style.display = "none";
}
